import React from "react";
import styled from "styled-components";
import {boxBorderColour, boxShadowColour} from "../../style/styleConsts";

const TableContainer = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 4px;
    outline: none;
    box-shadow: ${boxShadowColour} 0px 2px 1px 0px;
    border: 1px solid ${boxBorderColour};
    padding: 10px 16px 24px;
`;

export default TableContainer;